import { RootState } from 'src/store';

const getMyPDDState = (state: RootState) => state.myPDD;

export const getMyPDDLoans = (state: RootState) =>
  getMyPDDState(state)?.loans || [];

export const getMyPDDPendingCount = (state: RootState) =>
  getMyPDDState(state)?.pendingPDD || 0;

export const getMyPDDCriticalCount = (state: RootState) =>
  getMyPDDState(state)?.criticalPDD || 0;

export const getMyPDDLoading = (state: RootState) =>
  Boolean(getMyPDDState(state)?.loading);

export const getMyPDDError = (state: RootState) =>
  getMyPDDState(state)?.error || '';
